import { render } from "./DivWrapperScreen.vue?vue&type=template&id=82edf00e&scoped=true"
import script from "./DivWrapperScreen.vue?vue&type=script&lang=js"
export * from "./DivWrapperScreen.vue?vue&type=script&lang=js"

import "./DivWrapperScreen.vue?vue&type=style&index=0&id=82edf00e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82edf00e"]])

export default __exports__